exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chartist-tooltip-wrap\r\n{\r\n    position: relative;\r\n}\r\n\r\n.chartist-tooltip\r\n{\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n\r\n    position: absolute;\r\n    z-index: 1; \r\n\r\n    display: inline-block;\r\n\r\n    padding: 3px 8px;\r\n\r\n    text-align: center;\r\n    text-align: center;\r\n    pointer-events: none;\r\n\r\n    color: #fff;\r\n    border-radius: 3px;\r\n    background-color: rgba(0, 0, 0, .7);\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!G:/3csoft/client-final/node_modules/postcss-loader?{"ident":"postcss"}!G:/3csoft/client-final/src/vendor/chartist-plugin-tooltip/chartist-plugin-tooltip.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/vendor/chartist-plugin-tooltip/chartist-plugin-tooltip.css
// module chunks = styles